<rt-dropdown>
  @if (header) {
    <rt-dropdown-header>
      {{ header }}
    </rt-dropdown-header>
  }
  <div #scrollWrap rtScrollable class="scroll-wrap">
    @for (item of items; track trackByItem($index, item)) {
      <rt-dropdown-item
        [hasHoverEffect]="!item.disabled"
        [rtTooltip]="item.tooltip"
        [rtTooltipEnabled]="!!item.tooltipEnabled"
        [rtTooltipPosition]="item.tooltipPosition ? item.tooltipPosition : 'above'"
        (click)="!item.disabled && selectionChange.emit(item.value)"
        [class.disabled]="!!item.disabled"
      >
        @if (item.icon) {
          <rt-icon
            prefix
            [name]="item.icon"
            [colorToken]="$any(item.disabled ? 'colorIconDisabled' : 'colorIconDefault')"
          >
          </rt-icon>
        }
        <div layout layout-align-items-center>
          {{ item.option }}
          @if (item.badgeTemplate) {
            <ng-container [ngTemplateOutlet]="item.badgeTemplate"></ng-container>
          }
        </div>
      </rt-dropdown-item>
    }
  </div>
</rt-dropdown>
